import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Order, OrderStatusData } from '../redux/types'
import { formatDateTime } from 'util/masks'
import { ApplicationState } from 'AppReducer'
import { changeOrderStatus } from '../redux/actions'

const initialState: OrderStatusData = {
  status: 'PENDING',
  payment: {
    type: 'CARD_MACHINE',
    method: 'CREDIT'
  }
}

const Orderhistory: React.FC<{ order: Order }> = ({ order }) => {
  const dispatch = useDispatch()
  const [isFetching, setFetching] = useState(false)
  const [form, setForm] = useState<OrderStatusData>(initialState)

  const { orderStatusList } = useSelector((state: ApplicationState) => state.orderStatusReducer)

  async function handleOrderStatus (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    const { partner } = order
    if (partner?.id) {
      setFetching(true)
      await changeOrderStatus(partner.id, order.id, form)(dispatch)
      setFetching(false)
    }
  }

  useEffect(() => {
    setForm({
      status: order.status.name || 'PENDING',
      payment: {
        type: order.paymentType,
        method: order.paymentMethod
      }
    })
  }, [order])

  return (
    <div className="row">
      <form className="row margin-bottom-16" onSubmit={handleOrderStatus}>
        <div className="row bordered border-radius padding-8 align-end" style={{ width: '100%' }}>
          <div className="grow form-control">
            <label>Status</label>
            <select value={form.status} onChange={(e): void => setForm({ ...form, status: e.target.value })}>
              {
                orderStatusList.map((list, i) => {
                  return (
                    <option key={i} value={list.name}>{ list.alias }</option>
                  )
                })
              }
            </select>
          </div>
          <button className="secondary" style={{ width: 200 }} disabled={isFetching}>
            { isFetching ? 'Alterando...' : 'Alterar'}
          </button>
        </div>
      </form>

      {
        order.history.map((history, i) => {
          const status = orderStatusList.find(status => status.name === history.status)
          if (!status) return null

          return (
            <div className="row margin-top-8" key={i}>
              <div className="row panel" style={{ padding: 12, borderLeft: `5px solid ${status.color}` }}>
                <div className="row">
                  <i className={`fa fa-${status.icon}`}></i>

                  <div className="grow">
                    <div className="row">
                      <h4 className="col-6">
                        { status.alias }
                      </h4>

                      <p className="col-6 row justify-end">
                        { formatDateTime(history.createdAt) }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }

    </div>
  )
}

export default Orderhistory
